import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { Editicon, Deleteicon, XCircleblack } from "../../../../Components/IconComponents";
import { toast, ToastContainer } from "react-toastify";
import Table from "../../../../Components/UiComponents/Table/Table";
import Moment from "react-moment";
import Loader from "react-spinner-loader";
import {
  agencyTableData,
  columnsForExport,
} from "../../../../JsonData/AgencyConfig";
import { getData, putDataWithBody } from "../../../../Services/Services";
import { agencyListURL, deleteAgencyURL } from "../../../../Services/EndPoints";
import { useDispatch } from "react-redux";
import {
  filterDate,
  getExportedColumnsData,
} from "../../../../Components/UiComponents/utils";
import { setTableData } from "../../../../CentralStore/ExportLMSTable/dataSlice";
import Confirmpopup from "../../Common/ConfirmPopup/Confirmpopup";
import StatusHandler from "../../Common/StatusHandler/StatusHandler";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import { ThemeContext } from "../../../..";
const AgencyTable = forwardRef((props, ref) => {
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const qs = require("qs");
  const [agencyData, setAgencyData] = useState([]);
  const navigate = useNavigate();
  const [rowCount, setRowCount] = useState(0);
  const { t } = useTranslation();
  const [searchData, setSearchData] = useState([]);
  const { theme } =useContext(ThemeContext);
  useEffect(() => {
    if (props.locationInstance && props.locationInstance.msg != "") {
      toast.success("Agency has been created successfully.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000, // Close after 2 seconds..
      });
    }
    getAgecnyList();
  }, []);
  useEffect(() => {
    sendDataToCentralStore(searchData);
  }, [searchData]);

  const sendDataToCentralStore = (data) => {
    if (data.length > 0) {
      const columns = columnsForExport;
      dispatch(
        setTableData({
          columns,
          tableData: getExportedColumnsData(columns, data),
        })
      );
    }
  };
  const addNewHandler = () => {
    navigate("/agency-list/create-agency");
  };

  const getAgecnyList = async () => {
    setLoader(true);
    var agencyList = await getData(agencyListURL);
    let sortedList = agencyList.sort((a, b) => {
      return new Date(b.created_on) - new Date(a.created_on);
    });
    setLoader(false);
    setAgencyData(sortedList);
    setRowCount(sortedList.length);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: t("agencytableheaders.name"),
        accessor: "name",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            let descriptionText = props.value;
            if (props.value.length > 50) {
              descriptionText = props.value.substring(0, 30) + "...";
            }
            return <span title={props.value}>{descriptionText}</span>;
          } else {
            return "NA";
          }
        },
      },
      {
        Header: t("agencytableheaders.agencytype"),
        accessor: "agency_type",
        Cell: (props) => {
          if (props.value) {
            let descriptionText = props.value;
            if (props.value.length > 50) {
              descriptionText = props.value.substring(0, 30) + "...";
            }
            return <span title={props.value}>{descriptionText}</span>;
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
      },
      {
        Header: t("agencytableheaders.description"),
        accessor: "description",
        disableSortBy: true,
        Cell: (props) => {
          const [showModal, setShowModal] = useState(false);
          const [fullDescription, setFullDescription] = useState("");
          const [highlightedDescription, setHighlightedDescription] = useState(""); // New state for highlighted description
      
          const handleShowModal = (description) => {
            setFullDescription(description);
            setHighlightedDescription(description); // Set the description being viewed to highlight
            setShowModal(true);
          };
      
          const handleCloseModal = () => {
            setShowModal(false);
            setHighlightedDescription(""); // Reset the highlighted description when the modal is closed
          };
      
          const descriptionText = props.value || "NA";
          const truncatedDescription = descriptionText.length > 25 ? `${descriptionText.substring(0, 25)}...` : descriptionText;
      
          // Apply background color if the description is currently being viewed in the modal
          const isHighlighted = descriptionText === highlightedDescription;
          if(showModal){
            setTimeout(() => {
              let el = document.querySelector('.modal-content')
              el.style.cssText = 'background-color: #1c2038 !important;border-radius: 20px !important;'
            }
              ,0)
          }
      
          return (
            <span>
              <span
                title={descriptionText} // Tooltip with full description on hover
                style={{
                  cursor: 'pointer',  // Added pointer cursor to indicate clickability
                  backgroundColor: isHighlighted ? '#18A3A0' : 'transparent', // Highlight background when viewed
                  padding: '2px 5px', // Add padding to give a little space around the text
                  borderRadius: '5px', // Rounded corners for the highlighted background
                }}
                onClick={() => handleShowModal(descriptionText)} // Open the modal with full description
              >
                {truncatedDescription}
              </span>
      
              {/* Modal to display the full description */}
              <Modal
                show={showModal}
                onHide={handleCloseModal}
                dialogClassName="custom-modal"
                centered
                style={{
                  borderRadius: '20px',  // Smooth rounded edges
                  border: 'none',        // Remove border to avoid white edges
                  top: '20%',  
                }}
              >
                <Modal.Header
                  style={{
                    backgroundColor: theme === "light" ? "#2b6591" : '#1c2038', // Dark blue background for header
                    color: 'white',              // White text in the header
                    borderBottom: 'none',       // Remove bottom border to prevent white edges
                  }}
                >
                  <Modal.Title style={{ color: 'white' }}>Full Description</Modal.Title>
                  <XCircleblack
                    onClick={handleCloseModal}
                    width="1.5em"
                    height="1.5em"
                    className="cursor-pointer"
                  />
                </Modal.Header>
                <Modal.Body
                  style={{
                    backgroundColor: theme === "light" ? "#fcfcfc" : '#252b48', // Blue background for body
                    color: theme === "light" ? "#001b30" : 'white',              // White text in the body
                    border: 'none',              // Remove border to prevent white edges
                    borderRadius: '0px',        // Remove radius to make it seamless
                    padding: '20px',             // Added padding for spacing
                    lineHeight: '1.8', 
                  }}
                >
                  <p>{fullDescription}</p>
                </Modal.Body>
                <Modal.Footer
                  style={{
                    backgroundColor: theme === "light" ? "#fcfcfc" : '#252b48', // Darker blue footer
                    color: 'white',              // White text in footer
                    borderTop: 'none',          // Remove top border to prevent white edges
                  }}
                >
                  <Button
                    variant="secondary"
                    onClick={handleCloseModal}
                    style={{
                      backgroundColor: theme === "light" ? "#2b6591" : '#252b48', // Dark blue button
                      borderColor: '#003366',     // Dark border for button
                      borderRadius: '5px',        // Rounded button edges
                    }}
                  > 
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </span>
          );
        },
      },      
      // {
      //   Header: "Status  ",
      //   accessor: "status",
      //   disableSortBy: true,
      //   Cell: (props) => {
      //     return <StatusHandler props={props} />;
      //   },
      // },
      {
        Header: t("agencytableheaders.createdon"),
        accessor: "created_on",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            return <Moment format="DD/MM/YYYY, HH:mm ">{props.value}</Moment>;
          } else {
            return "NA";
          }
        },
      },
      ,
      {
        Header: t("agencytableheaders.action"),
        disableSortBy: true,

        Cell: (props) => {
          const [isdelete, setIsdelete] = useState(false);
          const deletePopUp = () => {
            setIsdelete(!isdelete);
          };
          const deleteTableDataById = async (id) => {
            let data = { id: id };
            var res = await putDataWithBody(deleteAgencyURL, data, {});
            if (res.status == "success") {
              getAgecnyList();
            }
            toast.success(res.msg, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000, // Close after 2 seconds
            });
            setIsdelete(false);
          };

          return (
            <div className="usertable__actionsicon">
              <span
                onClick={() =>
                  navigate("/agency-list/create-agency", {
                    state: {
                      data: props.row.original,
                      edit: true
                    },
                  })
                }>
                <Editicon value={props.value} className="cursor-pointer me-2" />
              </span>

              <span onClick={deletePopUp}>
                <Deleteicon
                  value={props.value}
                  className="cursor-pointer mr-1"
                />
              </span>

              {isdelete && (
                <Confirmpopup
                  className="DeltePopup"
                  show={isdelete}
                  title={t("deletepopuptext")}
                  message={t("deletepopupmessage")}
                  handleToggle={deletePopUp}
                  row={props.row}
                  name={props.row.original.name}
                  deleteRow={deleteTableDataById}
                  cancel={t("cancelbutton")}
                  action={t("actionbutton")}
                />
              )}
            </div>
          );
        },
      },
    ],
    [t]
  );
  return (
    <div className="create-user">
      <Loader
        show={loader}
        type="body"
        stack="vertical"
        message="Loading Data"
      />
      <div className="datatable__container">
        {agencyTableData && (
          <Table
            data={agencyData}
            setSearchData={setSearchData}
            columns={columns}
            numberOfRows={10}
            addNewHandler={addNewHandler}
            showExport={false}
            showFilter={false}
            addButtonLabel={t("createagencyaddbuttonlabel")}
            showReset={false}
            onExpand={false}
            rowCount={rowCount} // Pass rowCount to the Table component
            headerTableHeadStyle={{ background: "#18a3a0", color: "#FFFFFF" }}
            tableStyle={{
              border: "1px solid  #f0f0f0",
              borderRadius: "12px",
            }}
          />
        )}
      </div>
    </div>
  );
});

export default AgencyTable;
